module.exports = __webpack_public_path__ + "img/30f10.d9d86f6e.jpg";